import { __assign, __decorate, __extends } from "tslib";
import * as React from 'react';
import s from './mobile-search-box.scss';
import X from 'wix-ui-icons-common/X';
import { MobileSearchContainer } from '../../../components/search-box/mobile-search';
import { Suggestion } from '../../../components/search-box/search-suggestions-container/suggestion';
import { PopularSuggestions } from '../../../components/search-box/search-suggestions-container/popular-suggestions';
import { AppsSuggestions } from '../../../components/search-box/search-suggestions-container/apps-suggestions';
import { CategoriesSuggestions } from '../../../components/search-box/search-suggestions-container/categories-suggestions';
import { defaultSuggestions } from '../../../components/search-box/search-suggestions-container/static-data/default-suggestions';
import { Text } from 'wix-style-react';
import { withBiLogger } from '../../../component-decorators/with-bi-logger';
import { withMarketplaceStore, } from '../../../component-decorators/with-marketplace-store';
import { config } from '../../../config';
import { Path } from '../../../enums/marketplace-enums';
import { getPathForBi } from '../../../common/bi-events';
import { ConfigContextConsumer } from '../../../config-context';
import { withTranslation } from '../../../component-decorators/with-translation';
import { SuggestionType } from '../../../types/common/marketplace';
var MobileSearchBox = /** @class */ (function (_super) {
    __extends(MobileSearchBox, _super);
    function MobileSearchBox(props) {
        var _this = _super.call(this, props) || this;
        _this.sendSearchSearchClickBi = function (search_term, search_type, index) {
            var _a = _this.props, biLogger = _a.biLogger, marketplaceStore = _a.marketplaceStore, toggleSearchBox = _a.toggleSearchBox;
            biLogger.searchSearchClick({
                market: config.originForBI,
                search_term: search_term,
                msid: marketplaceStore.metaSiteId,
                search_type: search_type,
                search_location: 'mobile_menu',
                index: index,
                tag_type: getPathForBi(_this.props.marketplaceStore.route.path),
            });
            toggleSearchBox();
        };
        _this.state = {
            suggestions: [],
            defaultSuggestions: [],
            searchValue: '',
        };
        return _this;
    }
    MobileSearchBox.prototype.render = function () {
        var _this = this;
        var _a = this.state, suggestions = _a.suggestions, searchValue = _a.searchValue;
        var _b = this.props, isSearchMenuOpen = _b.isSearchMenuOpen, toggleSearchBox = _b.toggleSearchBox, t = _b.t;
        return (React.createElement(ConfigContextConsumer, null, function (configContext) { return (React.createElement("div", { className: s.mobileSearch + " " + (isSearchMenuOpen ? s.open : '') },
            React.createElement("div", { className: s.inner },
                React.createElement("span", { className: s.topSection },
                    React.createElement(MobileSearchContainer, { isInMenu: false, upadteSearchValue: function (newSearchValue) {
                            return _this.setState({ searchValue: newSearchValue });
                        }, updateSuggestions: function (newSuggestions) {
                            return _this.setState({ suggestions: newSuggestions });
                        }, locale: configContext.locale, toggleSearchBox: toggleSearchBox }),
                    React.createElement(X, { onClick: toggleSearchBox, className: s.xIcon })),
                !searchValue.length && (React.createElement(React.Fragment, null,
                    React.createElement(Text, { weight: "thin", className: s.topicsTitle }, "Trending Topics"),
                    defaultSuggestions.map(function (item, index) {
                        return (React.createElement(Suggestion, __assign({ onClick: function (e, _a) {
                                var value = _a.value, idx = _a.index;
                                _this.sendSearchSearchClickBi(t(value), 'popular', idx);
                                config.goto({ path: Path.SEARCH, query: t(value) });
                            }, key: index }, item, { selected: false, index: index })));
                    }))),
                React.createElement(PopularSuggestions, { onSearchValueChange: function () { }, searchTerms: suggestions.filter(function (item) { return item.suggestionType === SuggestionType.SEARCH; }), searchValue: searchValue, sendSearchSearchClickBi: _this.sendSearchSearchClickBi }),
                React.createElement(AppsSuggestions, { onSearchValueChange: function () { }, searchValue: searchValue, sendSearchSearchClickBi: _this.sendSearchSearchClickBi, apps: suggestions.filter(function (item) { return item.suggestionType === SuggestionType.APP; }) }),
                React.createElement(CategoriesSuggestions, { onSearchValueChange: function () { }, searchValue: searchValue, sendSearchSearchClickBi: _this.sendSearchSearchClickBi, categories: suggestions.filter(function (item) { return item.suggestionType === SuggestionType.CATEGORY; }) })))); }));
    };
    MobileSearchBox = __decorate([
        withBiLogger,
        withMarketplaceStore,
        withTranslation
    ], MobileSearchBox);
    return MobileSearchBox;
}(React.PureComponent));
export { MobileSearchBox };
//# sourceMappingURL=mobile-search-box.js.map